import React from 'react';
import Header from '../components/Header';
import Projects from '../components/Projects';
import Footer from '../components/Footer';

const Home: React.FC = () => {
  return (
    <div className="home">
      <Header />
      <Projects />
      <Footer />
    </div>
  );
};

export default Home;